import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';
import { srOnlyStyle } from '../../../styles/styles';

const { colors, typography, common } = THEME;

export const styleSheet = StyleSheet.create({
	board: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[12],
	},
	iconTile: {
		width: 40,
		height: 40,
		flexShrink: 0,
		display: 'grid',
		placeItems: 'center',
		borderRadius: common.borderRadius,
	},
	heading: {
		flex: 1,
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	title: {
		margin: 0,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.standard,
		color: colors.text.main,
	},
	summary: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: SPACE[4],
		fontSize: typography.fontSizes.sm,
		color: colors.text.light,
	},
	toggleAll: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: SPACE[4],
		whiteSpace: 'nowrap',
		paddingRight: '0 !important',
	},
	chevron: {
		transition: 'transform 150ms ease',
	},
	chevronOpen: {
		transform: 'rotate(180deg)',
	},
	emptyText: {
		margin: 0,
		fontSize: typography.fontSizes.sm,
		color: colors.text.light,
	},
	tableScroller: {
		overflowX: 'auto',
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		background: colors.background.light,
	},
	table: {
		minWidth: 'min-content',
	},
	gridRow: {
		display: 'grid',
		gap: SPACE[16],
		alignItems: 'center',
		padding: `${SPACE[12]}px ${SPACE[16]}px`,
	},
	headerRow: {
		background: colors.hover.light,
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		color: colors.text.main,
	},
	rowGroup: {
		borderTop: `1px solid ${colors.border.light}`,
	},
	bodyRow: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
	},
	nameCell: {
		minWidth: 0,
		overflowWrap: 'break-word',
		fontWeight: typography.fontWeights.bold,
	},
	cell: {
		minWidth: 0,
		overflowWrap: 'break-word',
	},
	statusCell: {
		display: 'flex',
		minWidth: 0,
		maxWidth: '100%',
	},
	alignEnd: {
		textAlign: 'right',
	},
	trailingCell: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		gap: SPACE[4],
	},
	link: {
		color: colors.primary.main,
		textDecoration: 'none',
		':hover': {
			color: colors.hover.main,
			textDecoration: 'underline',
		},
		':focus-visible': {
			color: colors.hover.main,
			textDecoration: 'underline',
		},
	},
	chevronButton: {
		color: colors.primary.main,
	},
	detailsRow: {
		padding: `${SPACE[12]}px ${SPACE[16]}px ${SPACE[16]}px`,
		borderTop: `1px dashed ${colors.border.light}`,
	},
	detailsList: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: `${SPACE[12]}px ${SPACE[40]}px`,
		fontSize: typography.fontSizes.sm,
	},
	detail: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		minWidth: 0,
	},
	detailLabel: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
	},
	detailValue: {
		color: colors.text.main,
		overflowWrap: 'anywhere',
		whiteSpace: 'pre-wrap',
	},
	addItemName: {
		[THEME.queries.lg]: srOnlyStyle,
	},
	addButtonDisabled: {
		opacity: 0.5,
		cursor: 'not-allowed',
	},
	actionsContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
	},
});

const whiteIcon = { color: colors.primary.contrastText, fill: colors.primary.contrastText };

export const iconTileColors = StyleSheet.create({
	green: { backgroundColor: colors.success.main, ...whiteIcon },
	pink: { backgroundColor: colors.tertiary.main, ...whiteIcon },
	blue: { backgroundColor: colors.chart.enchantment, ...whiteIcon },
});
